import { WorkHereContainerRow, WorkHereContent } from './styled';
import { OneColumnExpanded } from '../../styled';
import { RouterLink } from '@redux-first-router-link';
import { ROUTE_CAREERS } from '@/constants/routes';

interface Props {
  title?: string;
  shortContentOne?: string;
  markdownContent: string[];
}

export const WorkHere = ({
  title,
  markdownContent,
  shortContentOne,
}: Props) => {
  return (
    <WorkHereContainerRow justifyContent="center" bgColor="#EAF3FF">
      <OneColumnExpanded>
        <WorkHereContent data-cy-id="workHere">
          <h2>{title}</h2>
          <p>{markdownContent[0]}</p>
          <RouterLink to={{ type: ROUTE_CAREERS }}>
            {shortContentOne}
          </RouterLink>
        </WorkHereContent>
      </OneColumnExpanded>
    </WorkHereContainerRow>
  );
};
